<template>
  <div>
    <div class="mt-5 pt-3">
      <h1>Report Direct to Customer</h1>
    </div>
    <snackbar :text=text :status=status v-if=text />

    <v-container style="max-width: 100%">
      <v-card>
        <waiting v-if="loading" />
        <tabs :active="0" :tabs="dtcTabs"></tabs>

        <v-divider class="mb-3"></v-divider>

        <v-layout wrap fill-height class="m-10">
          <v-flex xs12 sm12 md2 lg2 style="padding-top: 45px">
            <span> Sort By Date </span>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3>
            <v-flex xs1 style="margin: 0 10px"> Start </v-flex>
            <v-flex xs12>
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="detailedItem.start"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  class="m-10"
                  solo
                  slot="activator"
                  v-model="detailedItem.start"
                  append-icon="mdi-calendar"
                  label="Start Date"
                  @input="menu1 = false"
                ></v-text-field>
                <v-date-picker
                  v-model="detailedItem.start"
                  @input="$refs.menu1.save(detailedItem.start)"
                  no-title
                  scrollable
                  :allowed-dates="allowedDates"
                  next-icon="mdi-chevron-right"
                  prev-icon="mdi-chevron-left"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3>
            <v-flex xs1 style="margin: 0 10px"> End </v-flex>
            <v-flex xs12>
              <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="detailedItem.end"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  class="m-10"
                  solo
                  slot="activator"
                  v-model="detailedItem.end"
                  append-icon="mdi-calendar"
                  label="End Date"
                  @input="menu2 = false"
                ></v-text-field>
                <v-date-picker
                  v-model="detailedItem.end"
                  @input="$refs.menu2.save(detailedItem.end)"
                  no-title
                  scrollable
                  :allowed-dates="allowedDates"
                  next-icon="mdi-chevron-right"
                  prev-icon="mdi-chevron-left"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3 offset-md1 offset-lg1>
            <v-flex xs12> &nbsp;</v-flex>
            <v-flex xs12>
              <v-text-field
                class="m-10"
                solo
                clearable
                v-model="search"
                placeholder="Search"
                append-icon="mdi-magnify"
              >
              </v-text-field>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm12 md2 lg2 style="padding-top: 45px">
            <span> Filter by Order </span>
          </v-flex>

          <v-flex xs12 sm12 md3 lg3>
            <v-flex xs1 style="margin: 0 10px"> Number </v-flex>
            <v-flex xs12>
              <v-text-field
                clearable
                class="m-10"
                solo
                v-model="detailedItem.order_number"
                placeholder="Order Number"
              >
              </v-text-field>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm12 md3 lg3>
            <v-flex xs1 style="margin: 0 10px"> Status </v-flex>
            <v-flex xs12>
                <v-combobox
                  solo
                  class="m-10"
                  v-model="detailedItem.status"
                  :items="[
                    'All',
                    'Open',
                    'Stock-distribution',
                    'Delivery',
                    'Customer-Receipt',
                    'Retur',
                    'Cancel',
                    'Paid',
                    'Stock-Habis',
                    'Gagal-Send-Email',
                    'Fail-Sync'
                  ]"
                ></v-combobox>
            </v-flex>
          </v-flex>
          <v-flex xs6 sm4 md2 lg2 offset-xs6 offset-sm8 offset-md10 offset-lg10>
            <span @click="downloadHist" class="s-download">
              <v-icon small color="#27bb8b">mdi-download</v-icon>
              Download.csv
            </span>
          </v-flex>
        </v-layout>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="lists"
          :search="search"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          item-key="invoice_number"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          sort-icon="mdi-chevron-down"
          class="elevation-10"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{
                  props.index +
                  1 +
                  (pagination.page - 1) * pagination.rowsPerPage
                }}
              </td>
              <td class="text-xs-left">{{ props.item.created_date }}</td>
              <td class="text-xs-left">{{ props.item.sales_order_number }}</td>
              <td class="text-xs-left">{{ props.item.invoice_number }}</td>
              <td class="text-xs-left">{{ props.item.distributor_name }}</td>
              <td class="text-xs-left">{{ props.item.delivery_method }}</td>
              <td class="text-xs-left">{{ props.item.receiver_name }}</td>
              <td class="text-xs-left">{{ props.item.receiver_email }}</td>
              <td class="text-xs-left">{{ props.item.receiver_mobile }}</td>
              <td class="text-xs-left">{{ props.item.brand_name }}</td>
              <td class="text-xs-left">{{ props.item.sku_name }}</td>
              <td class="text-xs-center">
                {{ currency(props.item.quantity) }}
              </td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td class="text-xs-left">{{ props.item.delivery_date }}</td>
            </tr>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >Your search for "{{ search }}" found no results.</v-alert
          >
          <template slot="no-data" v-if="!loading">
            <v-alert :value="true" color="error" icon="mdi-alert"
              >No result for transactions.</v-alert
            >
            <v-btn color="green white--text" @click="resetFill"
              >Reset</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from '@/helpers/axios'
import { currency } from '@/helpers/currency'
import { downloadCSVfromJSON } from '@/helpers/download'
import Snackbar from '../Snackbar.vue'
import { mapState } from 'vuex'
import Tabs from '@/components/v2/Tabs'
import Waiting from '../Waiting.vue'

export default {
  name: 'DirectToCustomerSuccess',
  components: {
    Snackbar,
    Tabs,
    Waiting
  },
  data () {
    return {
      dialog: false,
      text: null,
      status: null,
      menu1: false,
      menu2: false,
      search: '',
      headers: [
        {
          text: 'No.',
          align: 'center',
          sortable: false,
          value: 'name',
          width: '5%'
        },
        { text: 'Order Date', value: 'created_date' },
        { text: 'Order Number', value: 'sales_order_no', sortable: false },
        { text: 'Invoice Number', value: 'invoice_number' },
        { text: 'Distributor', value: 'distributor_name' },
        { text: 'Delivery Method', value: 'delivery_method' },
        { text: 'Receiver Name', value: 'receiver_name' },
        { text: 'Receiver Email', value: 'receiver_email' },
        { text: 'Receiver Phone', value: 'receiver_mobile' },
        { text: 'Brand', value: 'brand_name' },
        { text: 'SKU Voucher', value: 'sku_name' },
        { text: 'QTY', value: 'quantity' },
        { text: 'Status', value: 'status' },
        { text: 'Delivery Date', value: 'delivery_date' }
      ],
      lists: [],
      detailedItem: {
        requestId: 'exampleTest',
        maxRecords: '300',
        currentPage: '1',
        start: new Date(Date.now() - 259200000).toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        order_number: '',
        status: 'All'
      },
      defaultItem: {
        requestId: 'exampleTest',
        maxRecords: '300',
        currentPage: '1',
        start: new Date(Date.now() - 259200000).toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        order_number: '',
        status: 'All'
      },
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 10000
      },
      loading: true,
      rowsPerPageItems: [10, 25, 50, 100]
    }
  },
  computed: {
    ...mapState(['idClient', 'token', 'receiver', 'expired', 'dtcTabs'])
  },
  methods: {
    currency: currency,
    allowedDates: function (val) {
      return val <= new Date().toISOString().substr(0, 10)
    },
    getTransByDate () {
      this.loading = true
      let { page, totalItems } = this.pagination

      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired
      }

      if (
        this.detailedItem.start !== this.defaultItem.start ||
        this.detailedItem.end !== this.defaultItem.end
      ) {
        this.pagination.page = 1
        page = 1
      }

      axios
        .post('/getDirectHistory', {
          request_id: `Req-${new Date().getTime()}-hist`,
          start_date: this.detailedItem.start + ' 00:00:00',
          end_date: this.detailedItem.end + ' 23:59:59',
          current_page: page,
          max_records: totalItems > 5 ? totalItems : 10000,
          source: 'front',
          sort: 'DESC',
          order_number: this.detailedItem.order_number,
          status: this.detailedItem.status === 'All' ? '' : this.detailedItem.status
        })
        .then((response) => {
          if (response.data.code === 'CLE002') this.text = response.data.message
          this.lists = response.data.data
          this.loading = false
        })
        .catch((error) => {
          this.lists = []
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
          this.loading = false
        })
    },
    resetFill () {
      this.search = ''
      this.detailedItem = Object.assign({}, this.defaultItem)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.detailedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },
    downloadHist () {
      downloadCSVfromJSON(this.lists, 'DirectToCustomer', true)
    }
  },
  mounted () {
    this.getTransByDate()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    text () {
      setTimeout(() => {
        this.text = null
        this.status = null
      }, 5000)
    },
    'detailedItem.start' (val) {
      this.getTransByDate()
    },
    'detailedItem.end' (val) {
      this.getTransByDate()
    },
    'detailedItem.order_number' (val) {
      this.getTransByDate()
    },
    'detailedItem.status' (val) {
      this.getTransByDate()
    }
  }
}
</script>

<style scoped>
.green {
  /* background: linear-gradient(25deg, #4dbd77, #4dbd99) !important; */
  background: #27bb8b !important
}

.m-10 {
  margin: 10px
}

.s-download {
  cursor: pointer;
  font-size: 12px;
  color: #27bb8b
}
</style>
